module.exports = __webpack_public_path__ + "img/plane.fbf33879.svg";